import { render, staticRenderFns } from "./Likert.vue?vue&type=template&id=360cb89c&scoped=true&"
import script from "./Likert.vue?vue&type=script&lang=js&"
export * from "./Likert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360cb89c",
  null
  
)

export default component.exports